// extracted by css-extract-rspack-plugin
export default {"groups":"groups-YERYLI","group":"group-xcdp6u","datasetCard":"datasetCard-HGSPci","checkboxSlot":"checkboxSlot-q6Cks7","groupHeading":"groupHeading-0IAyNH"};